import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { StatsSection } from '../components/StatsSection';
import { AboutSection } from '../components/AboutSection';
import { ServicesSection } from '../components/ServicesSection';
import { AppExperienceSection } from '../components/AppExperienceSection';
import { SecuritySection } from '../components/SecuritySection';
import { PartnersSection } from '../components/PartnersSection';
import { TrustedSection } from '../components/TrustedSection';
import { Footer } from '../components/Footer';
import { useLanguage } from '../hooks/useLanguage';
export function HomePage() {
  const {
    setLocale
  } = useLanguage();
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith('/ar')) {
      setLocale('ar');
    } else {
      setLocale('en');
    }
  }, [location.pathname, setLocale]);
  return <div className="min-h-screen w-full bg-white text-slate-900" data-id="element-720">
      <Header data-id="element-721" />
      <main data-id="element-722">
        <HeroSection data-id="element-723" />
        <StatsSection data-id="element-724" />
        <AboutSection data-id="element-725" />
        <ServicesSection data-id="element-726" />
        <AppExperienceSection data-id="element-727" />
        <SecuritySection data-id="element-728" />
        <PartnersSection data-id="element-729" />
        <TrustedSection data-id="element-730" />
      </main>
      <Footer data-id="element-731" />
    </div>;
}